import * as React from 'react';
import { Box } from '@material-ui/core';
import MuiGridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import {
  ListBase,
  useListContext,
  Title,
  TopToolbar,
  CreateButton,
  ExportButton,
  linkToRecord,
} from 'react-admin';

const useStyles = makeStyles((theme) => ({
  gridList: {
    margin: 0,
  },
  tileBar: {
    background:
      'linear-gradient(to top, rgba(0,0,0,0.8) 0%,rgba(0,0,0,0.4) 70%,rgba(0,0,0,0) 100%)',
  },
  placeholder: {
    backgroundColor: theme.palette.grey[300],
    height: '100%',
  },
  price: {
    display: 'inline',
    fontSize: '1em',
  },
  link: {
    color: '#fff',
  },
}));

const ListActions = () => (
  <TopToolbar>
    <CreateButton basePath="/ads" />
    <ExportButton />
  </TopToolbar>
);

const getColsForWidth = (width) => {
  if (width < 600) return 2;
  if (width < 960) return 3;
  if (width < 1280) return 4;
  if (width < 1920) return 5;
  return 6;
};

const GridList = () => {
  const { ids, data, basePath } = useListContext();
  const classes = useStyles();
  if (!ids || !data) return null;
  return (
    <MuiGridList
      cellHeight={180}
      cols={getColsForWidth(window.innerWidth)}
      className={classes.gridList}
    >
      {ids.map((id) => (
        <GridListTile
          component={Link}
          key={id}
          to={linkToRecord(basePath, data[id].id)}
        >
          <img src={data[id].image} alt="" />
          <GridListTileBar
            className={classes.tileBar}
            title={data[id].name}
            subtitle={data[id].description}
          />
        </GridListTile>
      ))}
    </MuiGridList>
  );
};

const AdsListView = ({ isSmall }) => {
  return (
    <>
      <Title defaultTitle={'Ads List'} />
      <ListActions />
      <Box display="flex">
        <Box width={isSmall ? 'auto' : 'calc(100%)'}>
          <GridList />
        </Box>
      </Box>
    </>
  );
};

export const AdsList = (props) => {
  return (
    <ListBase {...props}>
      <AdsListView />
    </ListBase>
  );
};
